export default {
  container: {
    marginBottom: "10px",
    background: "#FFFFFF",
    padding: "24px 24px 24px 24px",
    borderRadius: "8px",
    boxShadow: "0px 0px 8px 0px rgba(0, 0, 0, 0.05)",
  },
  filters: {},
  upperFilters: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
  },
  bottomFilters: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
  },
  chartContainer: {
    marginTop: "2rem",
  },
};
